<template>
  <div class="update-timezone-modal">
    <div class="update-timezone-wrapper">
      <div
        data-w-id="c1745711-39b1-0dc6-1fa3-cc98e464b4bd"
        class="link-block-5 w-inline-block"
        @click="cancel"
      >
        <img src="@/assets/timeslot-images/cancel.svg" loading="lazy" alt="" />
      </div>
      <div class="div-block-52">
        <h1 class="modal-heading">Update your timezone</h1>
      </div>
      <p class="paragraph-7">
        Receive sessions scheduled in your timezone. This change will affect all
        session timings.
      </p>
      <!--      <div class="div-block-77">-->
      <!--        <div class="text-block-63">Auto-detect timezone</div>-->
      <!--        <div-->
      <!--          data-w-id="d343fa42-d48c-cb50-7048-237739b939eb"-->
      <!--          class="div-block-78"-->
      <!--        >-->
      <!--          <div class="div-block-79"></div>-->
      <!--        </div>-->
      <!--      </div>-->
      <div>
        <!--        <select-->
        <!--          id="field"-->
        <!--          name="field"-->
        <!--          data-name="Field"-->
        <!--          class="select-field-2 w-select"-->
        <!--        >-->
        <!--          <option value="">America/Los-Angeles (GMT-0800)</option>-->
        <!--          <option value="First">First choice</option>-->
        <!--          <option value="Second">Second choice</option>-->
        <!--          <option value="Third">Third choice</option>-->
        <!--        </select>-->
        <FormulateInput
          type="select"
          validation="required"
          name="timezone"
          validation-name="Timezone"
          placeholder="Select your timezone"
          :options="timezones"
          v-model="updateModel.customerTimezone"
        />
      </div>
      <BaseComponentLoader
        v-if="loader.nonBlockingLoader"
        loaderAlignment="center"
      />
      <div v-else class="button-15 w-button" @click="update">
        Update
      </div>
    </div>
  </div>
</template>

<script>
import StoreUtils from "@/utils/BaseUtils/StoreUtils";
import { mapState } from "vuex";
import CustomerRequest from "@/model/requests/CustomerRequest";
import BaseComponentLoader from "@/components/BaseComponents/BaseComponentLoader";

export default {
  name: "UpdateTimezoneModal",
  components: { BaseComponentLoader },
  data() {
    return {
      updateModel: CustomerRequest.update
    };
  },
  props: {
    cancel: Function,
    time: Boolean
  },
  computed: {
    timezones() {
      return StoreUtils.rootGetters("customer/getTimezones");
    },
    timezoneList() {
      return this.timezones.map(data => {
        return {
          label: `${data.timeZoneName}:${data.timeZoneOffset}(${data.timeZoneAbbreviation})`,
          value: data.timeZoneName,
          id: data.timeZoneId
        };
      });
    },
    ...mapState({
      userInfo: state => state.auth.userInfo
    }),
    ...mapState(["loader"])
  },
  methods: {
    update() {
      this.updateModel.customerId = this.userInfo.customerId;
      StoreUtils.dispatch(
        StoreUtils.actions.customer.UPDATE_CUSTOMER,
        this.updateModel
      ).then(() => this.cancel());
    }
  },
  mounted() {
    StoreUtils.dispatch("customer/readTimezones");
  }
};
</script>

<style scoped></style>
